import { Action, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserSession } from '../../../common/dto/user-session.dto';
import { Observable } from 'rxjs';

export interface AppStateModel {
  isInitialized: boolean;

  isMobileMenuOpened: boolean;

  session?: UserSession;
}

export class SetIsInitializedAction {
  static readonly type = '[AppState] SetIsInitializedAction';
}

export class SetSessionAction {
  static readonly type = '[AppState] SetSessionAction';

  constructor(public session: UserSession | undefined) {}
}

export class OpenMobileMenuOpenedAction {
  static readonly type = '[AppState] OpenMobileMenuOpened';
}

export class CloseMobileMenuOpenedAction {
  static readonly type = '[AppState] CloseMobileMenuOpened';
}

export const AppStateName = 'appState';

export function selectAppState(store: Store): Observable<AppStateModel> {
  return store.select<AppStateModel>((state: any) => state[AppStateName]);
}

export function selectAppStateSnapshot(store: Store): AppStateModel {
  return store.selectSnapshot<AppStateModel>((state: any) => state[AppStateName]);
}

@State<AppStateModel>({
  name: AppStateName,
  defaults: {
    isInitialized: false,
    isMobileMenuOpened: false,
  },
})
@Injectable()
export class AppState {
  @Action(SetIsInitializedAction)
  setIsInitialized(ctx: StateContext<AppStateModel>, action: SetIsInitializedAction) {
    ctx.patchState({
      isInitialized: true,
    });
  }

  @Action(SetSessionAction)
  setSession(ctx: StateContext<AppStateModel>, action: SetSessionAction) {
    ctx.patchState({
      session: action.session,
    });
  }

  @Action(OpenMobileMenuOpenedAction)
  openMobileMenu(ctx: StateContext<AppStateModel>) {
    ctx.patchState({
      isMobileMenuOpened: true,
    });
  }

  @Action(CloseMobileMenuOpenedAction)
  closeMobileMenu(ctx: StateContext<AppStateModel>) {
    ctx.patchState({
      isMobileMenuOpened: false,
    });
  }
}
